import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import SinCorreo from './SinCorreo';
import logo from '../../../../assets/images/logo-small.png';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  FormControl,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import SeleccionarContacto from './SeleccionarContacto';
import { Redirect } from 'react-router-dom';
import ButtonBack from '../../Breadcrumb/ButtonBack';
import MensajeDeConfirmacionModal from '../../Notifications/MensajeDeConfirmacionModal';
import { LoadingButton } from '@mui/lab';
import { getContactosByUser } from '../../../../services/Auth/Contacto';
import Recaptcha from '../../Recaptcha';
import CustomizedSnackbars from '../../Notifications/CustomizedSnackbars';

export const OlvidePin = () => {
  const { handleSubmit } = useForm({ mode: 'onBlur' });
  const [username, setUsername] = useState('');
  const [contactos, setContactos] = useState(null);
  const [sinContacto, setSinContacto] = useState(false);
  const [openSeleccionar, setOpenSeleccionar] = useState(false);
  const [onCancelar, setOnCancelar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState('');
  const [recaptchaValidado, setRecaptchaValidado] = useState(false);
  const [openMensajeConfirmacion, setOpenMensajeConfirmacion] = useState(false);

  const handleCloseMensajeConfirmacion = () => {
    setOpenMensajeConfirmacion(false);
  };

  const onRecaptchaValidado = (validado) => {
    setLoading(false);
    setRecaptchaValidado(validado);
  };

  const onRecaptchaChange = () => {
    setLoading(true);
  };

  const onRecaptchaError = (e) => {
    setLoading(false);
  };

  const contactosHandler = (contactos) => {
    setLoading(true);
    setOpenSeleccionar(true);
    setContactos(contactos);
  };

  const sinContactoHandler = () => {
    setLoading(true);
    setSinContacto(true);
  };

  const cancelarHandler = () => {
    setOnCancelar(true);
  };

  const handleCloseSinContacto = () => {
    setSinContacto(false);
    setLoading(false);
  };

  const handleCloseSeleccionar = (contacto) => {
    setOpenSeleccionar(false);
    setLoading(false);
    setOpenMensajeConfirmacion(contacto ? true : false);
  };

  const recuperarPinHandler = async (data, e) => {
    setLoading(true);
    setResponse('');
    try {
      const res = await getContactosByUser(username);

      if (res !== undefined && res !== null && res.length > 0) {
        if (res.length === 1) {
          contactosHandler(res);
        } else {
          contactosHandler(res);
        }
      } else {
        sinContactoHandler(true);
      }
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {}, []);

  const handleBorrarMensaje = () => {
    setResponse('');
  };

  return onCancelar ? (
    <Redirect
      to={{
        pathname: '/',
        state: { from: '/signin' },
      }}
    />
  ) : (
    <Container component='main' maxWidth='sm' sx={{ p: 0 }}>
      <ButtonBack />
      <Card>
        <CardContent sx={{ mt: 2 }}>
          <Grid
            container
            direction='column'
            justifyContent='center'
            alignItems='center'
            gap={2}
            mb={4}
          >
            <Avatar alt='OSER' src={logo} sx={{ width: 70, height: 70 }} />
            <Typography gutterBottom variant='h5' component='h2'>
              Olvidé Contraseña
            </Typography>
          </Grid>

          <form onSubmit={handleSubmit(recuperarPinHandler)}>
            <CardContent>
              <FormControl fullWidth={true} variant='outlined' margin='normal'>
                <TextField
                  variant='standard'
                  margin='normal'
                  required
                  fullWidth
                  id='username'
                  label='Usuario'
                  name='username'
                  autoFocus
                  value={username || ''}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <Recaptcha
                  sitekey={process.env.REACT_APP_IOSPER_RECAPTCHA_SITE_KEY_SECRET}
                  onRecaptchaValidado={onRecaptchaValidado}
                  onChange={onRecaptchaChange}
                  onError={onRecaptchaError}
                />
              </FormControl>
            </CardContent>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', gap: 2 }}>
              <Button
                variant='contained'
                size='medium'
                color='neutral'
                onClick={cancelarHandler}
                sx={{ width: { xs: '100%', sm: 'auto' } }}
              >
                Cancelar
              </Button>
              <LoadingButton
                variant='contained'
                size='medium'
                color='primary'
                type='submit'
                disabled={!recaptchaValidado || username === ''}
                loading={loading}
                sx={{ width: { xs: '100%', sm: 'auto' } }}
              >
                Recuperar Contraseña
              </LoadingButton>
            </Box>
          </form>
        </CardContent>
      </Card>

      <SinCorreo open={sinContacto} onClose={handleCloseSinContacto} />
      <SeleccionarContacto
        contactos={contactos}
        username={username}
        open={openSeleccionar}
        onClose={handleCloseSeleccionar}
      />
      <MensajeDeConfirmacionModal
        titleModal='Envio confirmado'
        messagePrimary='Se envió un correo a su casilla para completar la recuperación de su contraseña.'
        messageSecundary={'¿No recibió ningún correo? Recuerde revisar en el correo no deseado.'}
        open={openMensajeConfirmacion}
        onClose={handleCloseMensajeConfirmacion}
      />

      <CustomizedSnackbars
        open={response}
        severity='success'
        message={response}
        onDeleteMessage={handleBorrarMensaje}
      />
    </Container>
  );
};
